import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ErrorOutline from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({
    root: {
        height: `100%`,
        //padding: `0 ${theme.spacing(2)}px`,
        padding: theme.spacing(3),
        width: '100%',
        position: 'relative',
        //backgroundColor: theme.palette.background.default
    },
    paper: {
        height: `100%`,
        //padding: `0 ${theme.spacing(2)}px`,
        padding: theme.spacing(3),
        width: '100%',
        position: 'relative',
        textAlign: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle'
        //backgroundColor: theme.palette.background.default
    },
    errorDiv: {
        cursor: 'pointer',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
}));

const NoData = props => {
    const classes = useStyles();
    const { error, loading, actions } = props;
    function reloadPortfolio() {
        actions.loadPortfolios();
    }
    let isError = false
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Typography variant="h6" component="h5">
                    {props.message}
                </Typography>
                {!loading && isError && <div onClick={reloadPortfolio} className={classes.errorDiv}>
                    <Typography>
                        <ErrorOutline fontSize="large" />
                    </Typography>
                    <Typography>
                        Error loading portfolios
                    </Typography>
                    <Typography>
                        click to retry
                    </Typography>
                </div>}
            </Paper>
        </div>
    );
};

NoData.propTypes = {
    message: PropTypes.string
};

export default NoData;